import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexbox, flexDirection, justifyContent, alignItems } from '../../styles/helpers/flexbox';
import { Wrapper } from '../strandard-item/styled';

const LoaderContainer = styled.div`
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('baseline')};

  flex: 1;
  margin-top: 60px;
  margin-left: 25%;
  position: fixed;
`;

const GridContainer = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
        ${flexbox()};
        ${flexDirection('column')};

        width: 100%;
        height: fit-content;

        .cell {
            width: 82px;
            height: 40px;
            background: ${colours.grey[300]};
          }
    `;
});

const CellContainer = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${flexDirection('column')};

    position: relative;
    top: 0;
    border-bottom: 1px solid ${colours.grey[400]};
    border-right: 2px dashed ${colours.grey[500]};

    ${Wrapper}:last-child & {
      border-right-style: solid;
    }
`;
});

const GridRow = styled.div`
  ${flexbox()};
  ${flexDirection('row')};
`;

const Header = styled.header((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
    ${flexbox()};

    position: sticky;
    top: 192px;
    z-index: 1;
    height: 47px;
    min-height: 47px;
    background-color: ${colours.grey[200]};
    border-right: 2px solid ${colours.grey[500]};
`;
});

const CBContainer = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
    ${flexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};

    border-right: 1px solid ${colours.grey[400]};
    border-left: 1px solid ${colours.grey[400]};
    background-color: ${colours.grey[200]};
    min-width: 52px;
    height: 47px;
`;
});

export {
  GridContainer,
  Header,
  CellContainer,
  LoaderContainer,
  CBContainer,
  GridRow
};
